import { httpClient, postProcessUpsert } from "@genai/http-client";
import {
  ApiCollection,
  CollectionId,
  EditCollectionForm,
} from "../model";
import { toCollection } from "./toCollection";

export function editCollection(
  collectionId: CollectionId,
  editCollectionForm: EditCollectionForm,
) {
  const fieldValueFormCollection = {
    name: editCollectionForm.name,
    organization: editCollectionForm.organization,
  };

  return httpClient(`/collections/${collectionId}`, {
    method: "PUT",
    body: JSON.stringify(fieldValueFormCollection),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(postProcessUpsert<ApiCollection>)
    .then(toCollection);
}
